import { qsa } from "@fluorescent/dom";
import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  sectionBlockItems: ".animation--section-introduction > *",
  items: ".mosaic-grid__item",
  itemContentsMobile: ".mosaic-grid__item + .mosaic-grid__text-container",
};

export default node => {
  if (!shouldAnimate(node)) return;

  const sectionBlockItems = qsa(selectors.sectionBlockItems, node);

  // Add the animation delay offset variables
  delayOffset(node, [selectors.sectionBlockItems, selectors.items]);
  delayOffset(node, [selectors.itemContentsMobile], sectionBlockItems.length);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
